import {
    EntryTypeBlockData,
    EntryTypeBlockResponse,
    EntryTypeBlockListResponse,
    EntryTypeBlockCreateForm,
    EntryTypeBlockUpdateForm,
    EntryTypeBlockStatus,
    EntryTypeFieldData,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';
import { Locale } from 'chaika-enums';

const BASE_URL = '/api/block';

export class BlockApi {
    public static async create(id: string, entryTypeBlock: EntryTypeBlockCreateForm): Promise<void> {
        await axios.post(`${BASE_URL}/${id}/version`, { entryTypeBlock });
    }

    public static async update(id: string, version: number, entryTypeBlock: EntryTypeBlockUpdateForm): Promise<void> {
        await axios.put(`${BASE_URL}/${id}/version/${version}`, { entryTypeBlock });
    }

    public static async updateStatus(id: string, version: number, status: EntryTypeBlockStatus): Promise<void> {
        await axios.put(`${BASE_URL}/${id}/version/${version}/status`, { entryTypeBlock: { status } });
    }

    public static async remove(id: string, version: number): Promise<void> {
        await axios.delete(`${BASE_URL}/${id}/version/${version}`);
    }

    public static async getList(): Promise<EntryTypeBlockData[]> {
        const res = await axios.get<EntryTypeBlockListResponse>(`${BASE_URL}`);

        return res.data.entryTypeBlocks;
    }

    public static async getFields(locale?: Locale): Promise<EntryTypeFieldData[]> {
        const res = await axios.get<{ fields: EntryTypeFieldData[] }>(`${BASE_URL}/fields`, { params: { locale } });

        return res.data.fields;
    }

    public static async getBlockVersion(blockId: string, version: number): Promise<EntryTypeBlockData> {
        const res = await axios.get<EntryTypeBlockResponse>(`${BASE_URL}/${blockId}/version/${version}`);

        return res.data.entryTypeBlock;
    }
}

export { BASE_URL as BLOCK_API_BASE_URL };
